import { render, staticRenderFns } from "./crazyWorm.vue?vue&type=template&id=1da27079&scoped=true"
import script from "./crazyWorm.vue?vue&type=script&lang=js"
export * from "./crazyWorm.vue?vue&type=script&lang=js"
import style0 from "./crazyWorm.vue?vue&type=style&index=0&id=1da27079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da27079",
  null
  
)

export default component.exports